import { X } from 'lucide-react';

export type MobileAction = [string, () => void, 'danger'?];

export function MobileActionSheet({ title, actions, onClose }: { title: string; actions: MobileAction[]; onClose: () => void }) {
  return (
    <div className="mobile-modal-backdrop" role="presentation" onClick={onClose}>
      <section className="mobile-action-sheet" role="dialog" aria-modal="true" aria-label={title} onClick={(event) => event.stopPropagation()}>
        <div className="mobile-action-head">
          <strong>{title}</strong>
          <button type="button" onClick={onClose} aria-label="Close"><X size={19} /></button>
        </div>
        {actions.map(([label, action, tone]) => (
          <button
            type="button"
            className={tone === 'danger' ? 'danger' : ''}
            key={label}
            onClick={() => {
              onClose();
              action();
            }}
          >
            {label}
          </button>
        ))}
      </section>
    </div>
  );
}
